import React, {  Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import {
	checkServicePrices,
} from '../../redux/actions';

class AddServicesOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			availableServices: [],
			currentlySelectedServices: [],
            errorMessage: '',
            otherServices: [],
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('AddServicesOverlayDialog');
		this.props.resetSelectedSKU && this.props.resetSelectedSKU();
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		const self = this;
		let temp = self.props.items[self.props.selectedSKUIndex];
        const uncrateInd = temp.uncrateInd;
        temp = temp && temp.relatedServices?JSON.parse(JSON.stringify(temp.relatedServices)):[];
        const availableServices = self.props.availableServices;
        temp.forEach((item, i) => {
            // if service is added custom text field by user in that case we need to append that service manually so that it can displayed
            if (item.serviceId.length === 4 && item.serviceId.indexOf('M') === 0 && !self.props.availableServices.find(itm => itm.service === item.serviceId)) {
                availableServices.push({
                    service: item.serviceId,
                    serviceDescription: item.serviceName,
                    servicePrice: item.price
                });
            }
        });
		self.setState({
			currentlySelectedServices: JSON.parse(JSON.stringify(temp)),
            showDialog: self.props.showDialog,
            uncrateInd,
			availableServices: _.orderBy(availableServices.filter(item => item.service !== 'M038'), ['service'], ['asc'])
        });
	}
	handleYes(event) {
		event.preventDefault();
        const self = this;
        self.setState({
            errorMessage: "",
            currentlySelectedServices: _.orderBy(self.state.currentlySelectedServices, ['serviceId'], ['asc'])
        }, () => {
            // make pimdata service call and check geego_fg_uncrate_required
            // if any geego_fg_uncrate_required === 'Y' && itemLevelDisableUncrateDropdown = true then show error message on this screen and hold
            const skuListForPim = self.state.currentlySelectedServices.map(itm => itm.serviceId);
            self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
    			if(response.status) {
                    let uncrateInd = self.state.uncrateInd;
    				const responseObject = response.responseObject ? response.responseObject : null;
                    if(responseObject) {
                        uncrateInd = responseObject.find(itm => itm.geego_fg_uncrate_required === 'Y') ? 'Y' : uncrateInd;
                        if (uncrateInd === 'Y' && self.props.itemLevelDisableUncrateDropdown) {
                            self.setState({
                                errorMessage: "This service requires the product to be uncrated and this sales agreement does not include uncrating."
                            });
                        } else {
                            self.props.handleSelectedServices(self.state.availableServices, self.state.currentlySelectedServices, self.props.selectedSKUIndex, uncrateInd);
                        }
                    } else {
                        self.props.handleSelectedServices(self.state.availableServices, self.state.currentlySelectedServices, self.props.selectedSKUIndex, uncrateInd);
                    }
    			} else {
                    self.setState({
                        errorMessage: "Error occured while fetching pim data."
                    });
                }
    		});
        });
	}
	handleChangeServices(serviceId, price, serviceName, isCustomService, event) {
		let self = this,
            currentlySelectedServices = self.state.currentlySelectedServices;
        if(event.target.checked) {
         //  const availServices = self.state.availableServices.filter(availSvc => availSvc.service === serviceId);
            const parentItem = self.props.items.filter(parentIt => parentIt.item.trim() === self.props.selectedSKU.trim());
            currentlySelectedServices.push({
				serviceId: serviceId,
				checked: event.target.checked,
				price: price,
				serviceName: serviceName,
				quantity: parentItem && parentItem.length > 0 ? parentItem[0].returnQuantity !== undefined && parentItem[0].returnQuantity !== null ? parentItem[0].returnQuantity : parentItem[0].quantity : '',
				extendedPrice: price,
				isCustomService
			});
        } else {
            currentlySelectedServices = _.pullAllBy(currentlySelectedServices, [{ 'serviceId': serviceId }], 'serviceId')
        }
        self.setState({
            currentlySelectedServices: currentlySelectedServices,
            errorMessage: '',
        });
	}
    handleAddService(event) {
		event.preventDefault();
        const  { otherServices } = this.state;
        otherServices.push({
            service: '',
            serviceError: '',
            isValidService: false,
            errorMessage: '',
            serviceDescription: '',
            servicePrice: '',
            checked: false,
			isCustomService: true,
        })
		this.setState({
            otherServices
        }, () => {
            var myVar = setInterval(function(){
    			var div = document.getElementById("addServiceContainer");
    			div.scrollTop = div.scrollHeight - div.clientHeight + 43;
    			clearInterval(myVar);
    		}, 200);
        });
	}
    handleChangeCustomService(index, event) {
        const self = this;
        const { otherServices } = self.state;
        const service = event.target.value.toUpperCase();
        otherServices[index].service = service;
        otherServices[index].serviceError = '';
        otherServices[index].errorMessage = '';
        self.setState({
            otherServices
        }, () => {
            if (service.length === 4) {
                if (service.indexOf('M') === 0 && service !== 'M038') {
                    if (this.state.availableServices.find(itm => itm.service === service)) {
                        const { otherServices } = self.state;
                        otherServices[index].serviceError = 'error';
                        otherServices[index].errorMessage = 'Service already added';
                        self.setState({
                            otherServices
                        });
                    } else {
                        const requiredPayloadForServicePricing = self.props.requiredPayloadForServicePricing;
                        const servicesPayload = [{
                            ...requiredPayloadForServicePricing,
                            itemNumber: service
                        }];
                        // Get all orderable services prices list
                        self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
                            const { otherServices } = self.state;
                            if(resp.status) {
                                let unitPrice = null;
                                let description = null;
                                resp.responseObject = JSON.parse(resp.responseObject);
                                if (resp.responseObject.items[0].unitPrice) {
                                    unitPrice = resp.responseObject.items[0].unitPrice;
                                    description = resp.responseObject.items[0].description;
                                    self.props.checkServicePrices({ ...requiredPayloadForServicePricing, itemNumber: service },"requestType=itemStatus", itemStatus => {
                                        if(itemStatus.responseObject === "Active") {
                                            self.props.checkServicePrices({ ...requiredPayloadForServicePricing, itemNumber: service },"requestType=itemOrderabilityFlag", itemOrderabilityFlag => {
                                                if(itemOrderabilityFlag.responseObject === "Y") {
                                                    otherServices[index].servicePrice = unitPrice;
                                                    otherServices[index].serviceDescription = description;
                                                    otherServices[index].isValidService = true;
                                                    self.setState({
                                                        otherServices
                                                    });
                                                } else {
                                                    otherServices[index].serviceError = 'error';
                                                    otherServices[index].errorMessage = 'Service not offered in this zip code';
                                                    self.setState({
                                                        otherServices
                                                    });
                                                }
                                            });
                                        } else {
                                            otherServices[index].serviceError = 'error';
                                            otherServices[index].errorMessage = 'Service not offered in this zip code';
                                            self.setState({
                                                otherServices
                                            });
                                        }
                                    });
                                } else {
                                    otherServices[index].serviceError = 'error';
                                    otherServices[index].errorMessage = 'Pricing not found';
                                    self.setState({
                                        otherServices
                                    });
                                }
                            } else {
                                otherServices[index].serviceError = 'error';
                                otherServices[index].errorMessage = 'Pricing not found';
                                self.setState({
                                    otherServices
                                });
                            }
                        });
                    }
                } else {
                    const { otherServices } = self.state;
                    otherServices[index].serviceError = 'error';
                    otherServices[index].errorMessage = 'Invalid service';
                    self.setState({
                        otherServices
                    });
                }
            }
        });
    }
    render() {
		const self = this;
        const isThereAnyServices = self.state.availableServices.length + self.state.otherServices.length;
        return (
            <div className="overlayDialog" id="addServicesOverlayDialog" style={{visibility: (self.state.showDialog===true?'visible':'hidden')}}>
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={self.closeDialog.bind(this)}>×</a>
                    <div>
                        <h2 className="title">Add Services</h2>
                        {!isThereAnyServices
                            ?<p>Services available for: <b>{self.props.selectedSKU}</b></p>
                            :null
                        }
                        {self.state.errorMessage && <p className="red bold">{self.state.errorMessage}</p>}
                        {!isThereAnyServices
                            ?<p style={{color: '#092c74'}} className="bold">No services available for this product: {self.props.selectedSKU}</p>
                            :null
                        }
                    </div>
                    <form className="addServicesForm" name="addServicesForm" id="addServicesForm" action="">
                        {isThereAnyServices
                            ? <div>
                                <div id="addServiceContainer" style={{height: 300, overflow: 'scroll'}}>
                                    <table className="dataTableType2 addServicesTable">
                                        <thead>
                                            <tr>
                                                <th className="service">Service</th>
                                                <th className="price">Price<span className="unbold">(Each)</span></th>
                                                <th className="select">Select</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.availableServices.map((item, index) => {
                									return <tr key={index}>
                	                                   <td className="service" style={{fontSize:"12px"}}>
                	                                        {item.service}&nbsp;— {item.serviceDescription}
                	                                    </td>
                	                                    <td className="price">
                	                                        {self.props.formatAmount2Decimal(item.servicePrice)}
                	                                    </td>
                	                                    <td className="select">
                	                                        <input type="checkbox" defaultChecked={_.find(self.state.currentlySelectedServices, ['serviceId', item.service])?true:false} onChange={this.handleChangeServices.bind(this, item.service, item.servicePrice, item.serviceDescription, item.isCustomService)} />
                	                                    </td>
                	                                </tr>
                								})
                                            }
                                            {this.state.otherServices.map((item, index) => {
            									return <tr key={index}>
            	                                    <td className="service">
                                                        {item.isValidService
                                                            ? `${item.service} — ${item.serviceDescription}`
                                                            : <input type="text" className={item.serviceError} maxLength={4} value={item.service} name={`service${index}`} onChange={this.handleChangeCustomService.bind(this, index)} />
                                                        }
                                                        {item.errorMessage && <span className="red"><br />{item.errorMessage}</span>}
            	                                    </td>
            	                                    <td className="price">
            	                                        {self.props.formatAmount2Decimal(item.servicePrice)}
            	                                    </td>
            	                                    <td className="select">
            	                                        <input type="checkbox" disabled={!item.isValidService} defaultChecked={_.find(self.state.currentlySelectedServices, ['serviceId', item.service])?true:false} onChange={this.handleChangeServices.bind(this, item.service, item.servicePrice, item.serviceDescription, item.isCustomService)} />
            	                                    </td>
            	                                </tr>
            								})}
                                        </tbody>
                                    </table>
                                </div>
                                {!this.props.isPunchOutAccess &&
                                    <p>
                                        <a className="bold noUnderline uppercase addProductLink" href="" onClick={this.handleAddService.bind(this)}>+ <u>Add Service</u></a>
                                    </p>
                                }
    							<div>
    		                        <div className="noButtonContainer">
    		                            <a className="noButton blueButton" onClick={self.closeDialog.bind(this)}>Cancel</a>
    		                        </div>
    	                            <div className="yesButtonContainer">
    	                                <a className="blueButton yesButton" onClick={self.handleYes.bind(this)}>Yes</a>
    	                            </div>
                                </div>
                                <div className='d-block d-sm-none'>
    		                        <div className="noButtonContainer">
    		                            <a className="noButton blueButton" style={{fontSize:"12px"}} onClick={self.closeDialog.bind(this)}>Cancel</a>
    		                        </div>
    	                            <div className="yesButtonContainer">
    	                                <a className="blueButton yesButton"  style={{fontSize:"12px"}} onClick={self.handleYes.bind(this)}>Yes</a>
    	                            </div>
                                </div>
                            </div>
                            : <div>
                            {!this.props.isPunchOutAccess &&<p>
                                <a className="bold noUnderline uppercase addProductLink" href="" onClick={this.handleAddService.bind(this)}>+ <u>Add Service</u></a>
                            </p>}
                            <div className="yesButtonContainer d-none d-sm-block">
                                <a className="blueButton yesButton" onClick={self.closeDialog.bind(this)}>Ok</a>
                            </div>
                            <div className="yesButtonContainer d-block d-sm-none">
                                <a className="blueButton yesButton"  style={{fontSize:"12px"}} onClick={self.closeDialog.bind(this)}>Ok</a>
                            </div>
                        </div>
                    }
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
});

AddServicesOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(AddServicesOverlayDialog);
export default AddServicesOverlayDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/addServicesOverlayDialog.js